import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrazione = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 4" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-4",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "frazione",
				transform: "translate(361.111111, 138.888889)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-4",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 41.7777778,
						y: 14,
						width: 194.222222,
						height: 249.777778
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-5",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 41.7777778,
						y: 486.222222,
						width: 194.222222,
						height: 249.777778
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "_",
						fill: "#424548",
						fillRule: "nonzero",
						points: "277.777778 388.888889 277.777778 361.111111 0 361.111111 0 388.888889"
					})
				]
			})]
		})
	})]
});
export default SvgFrazione;
